<template>
  <transition name="fade">
    <div
      v-if="visible"
      :class="['m-poprun-message', type]"
      @click="closeMessage"
    >
      <img src="../../assets/images/closeIcon.png" alt="" />
      <div class="pop_message">
        {{ message }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: "",
      type: "",
      duration: 3000,
      timer: null,
    };
  },
  methods: {
    show(options) {
      this.message = options.message || "";
      this.type = options.type || "info";
      this.duration = options.duration || 1500;
      this.visible = true;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.visible = false;
      }, this.duration);
    },
    closeMessage() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
  },
};
</script>

<style scoped>
.pop_message {
  word-break: break-word;
}
.m-poprun-message {
  position: fixed;
  width: 80%;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  padding: 2.667vw 5.333vw;
  border-radius: 1.067vw;
  color: #fff;
  font-size: 16px;
  z-index: 1000;
  cursor: pointer;
  transition: all 0.3s ease;
  word-break: break-all;
}

.m-poprun-message.info {
  background-color: #909399;
}

.m-poprun-message.success {
  background-color: #67c23a;
}

.m-poprun-message.warning {
  background-color: #e6a23c;
}

/* .m-poprun-message.error {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f67a7a;
} */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-poprun-message {
  background: #101010;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.m-poprun-message img {
  margin-right: 8px;
  width: 20px;
  height: 20px;
}
.m-poprun-message.error {
  font-weight: 400;
  font-size: 16px;
  color: #ff4242;
}
</style>
